export default __webpack_public_path__ + "static/media/nguquy.1723be57.png";